<template>
    <div class="wrapper">

        <img
            v-lazy="image"
            alt="Category Header Image"
            class="image"
        >

    </div>
</template>

<script>
export default {

    props: {
        image: {
            type: String,
            default: '',
        },
    },

};
</script>

<style lang="scss" scoped>
.wrapper {
    @apply rounded-lg overflow-hidden;
}
.image {
    object-fit: cover;
    object-position: right;
    @apply block w-full h-64;
    @media (max-width: config("theme.screens.md")) {
        height: 175px;
    }
}
</style>
